import { Table } from 'antd'
import dayjs from 'dayjs'
import styled from 'styled-components'
import { ColumnsType } from 'antd/es/table'

import { Carrier, Supplier, Ticket } from '@types'

import ShareTicket from '../../ShareTicket'
import { ActionsCellContainer, FlexCol, FlexRow } from '../../StyledComponents'
import StatusTicket from '../../TicketModal/components/statusTicket'
import DataSection from './DataSection'
import NotesSection from './NotesSection'
import ObservationsSection from './ObservationsSection'
import FilesSection from './FilesSection'

interface TicketDetailProps {
  ticket: Ticket
}

const columns: ColumnsType = [
  {
    title: 'Trip ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: 'Fecha programada',
    dataIndex: 'withdrawalDate',
    key: 'withdrawalDate',
    render: (withdrawalDate: Date) =>
      withdrawalDate ? dayjs(withdrawalDate).format('YYYY/MM/DD HH:mm') : '-',
  },
  {
    title: 'Proveedor',
    dataIndex: 'supplier',
    key: 'supplier',
    render: (supplier: Supplier) => supplier?.businessName ?? '-',
  },
  {
    title: 'Transportista',
    dataIndex: 'carrier',
    key: 'carrier',
    render: (carrier: Carrier) => carrier?.businessName ?? '-',
  },
  {
    title: 'Viaje GMS',
    dataIndex: 'ticketSap',
    key: 'ticketSap',
    render: (ticketSap: string) => ticketSap ?? '-',
  },
  {
    title: 'Remito',
    dataIndex: 'deliveryNote',
    key: 'deliveryNote',
    render: (deliveryNote: string) => deliveryNote ?? '-',
  },
  {
    title: 'Acciones',
    key: 'acciones',
    dataIndex: 'id',
    align: 'center',
    render: id => (
      <ActionsCellContainer>
        <ShareTicket ticketId={id} />
      </ActionsCellContainer>
    ),
  },
]

const style = { sectionsGap: '1.25rem' }

const TicketTable = styled(Table)`
  .ant-table-cell {
    padding: 0.5rem;
  }
  th.ant-table-cell {
    border-bottom: solid 1px #00000050;
  }
`

const TicketDetail = ({ ticket }: TicketDetailProps) => (
  <FlexCol>
    <TicketTable
      style={{ overflowX: 'scroll' }}
      columns={columns}
      dataSource={[ticket]}
      pagination={false}
    />
    <StatusTicket status={ticket.status.name} />
    <FlexRow style={{ gap: style.sectionsGap, padding: '0.5rem', flexWrap: 'wrap' }}>
      <DataSection ticket={ticket} />
      <FlexCol style={{ gap: style.sectionsGap, flex: 1, minWidth: '16rem' }}>
        <FilesSection files={ticket.file} />
        <NotesSection notes={ticket.notes} />
        <ObservationsSection observations={ticket.observations} />
      </FlexCol>
    </FlexRow>
  </FlexCol>
)

export default TicketDetail
